import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div className="relative mx-auto px-4 pt-16 sm:max-w-xl md:max-w-full md:px-8 lg:py-32 xl:px-20">
      <img
        className="pointer-events-none absolute bottom-0 left-0 -z-10 opacity-[0.2] w-full "
        src="https://1drv.ms/i/s!AnslvumiieQ4g8Ep4KFdgQpUid1jJQ?embed=1&width=1024"
        alt="Background Graphic"
      />
      <div className="mx-auto max-w-xl lg:max-w-screen-xl">
        <div className="mx-auto mb-16 flex flex-col items-center text-center lg:mb-0 ">
          <div className="mb-6 ">
            <div>
              <p className="bg-teal-accent-400 mb-4 inline-block rounded-full px-3 py-px text-s font-semibold uppercase tracking-wider text-blue-900">
                WELCOME TO
              </p>
            </div>
            <h2 className="mb-6 max-w-lg inline-block font-sans text-3xl font-bold tracking-tight sm:text-4xl">
              GetOffThePavement.co.uk! <br />
            </h2>
            <p className="text-base text-gray-700 md:text-lg">
              Tired of cars blocking the pavement outside your property?
              Pavement parking is not only frustrating but can also be unsafe,
              especially for pedestrians, parents with prams, and people using
              wheelchairs. We’re here to make taking action easy.
            </p>
            <p className="text-base font-bold text-gray-700 md:text-lg"><br/>
              OWNER OF THE VEHICLE WILL NOT KNOW IT IS YOU UNLESS YOU WANT US TO
              REVEAL THIS INFORMATION. WE KEEP EVERYTHING ANONYMOUS AND
              CONFIDENTIAL.
            </p>
          </div>
          <div className="flex items-center">
            <Link
              to="/case-form"
              className="z-10 mr-6 inline-flex h-12 items-center justify-center rounded bg-cyan-900 px-6 font-medium tracking-wide text-white shadow-md outline-none transition duration-200 hover:bg-yellow-600 focus:ring"
            >
              Get started
            </Link>
            <Link
              to="/contactus"
              aria-label="Learn More"
              className="z-10 inline-flex items-center font-semibold text-cyan-900 transition-colors duration-200 hover:text-yellow-600"
            >
              Learn more
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
